/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_Not_ApplicableInputs */

const en_directory_agent_readiness_status_not_applicable = /** @type {(inputs: Directory_Agent_Readiness_Status_Not_ApplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not applicable`)
};

const zh_directory_agent_readiness_status_not_applicable = /** @type {(inputs: Directory_Agent_Readiness_Status_Not_ApplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不适用于该产品`)
};

/**
* | output |
* | --- |
* | "Not applicable" |
*
* @param {Directory_Agent_Readiness_Status_Not_ApplicableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_not_applicable = /** @type {((inputs?: Directory_Agent_Readiness_Status_Not_ApplicableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_Not_ApplicableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_not_applicable(inputs)
	return zh_directory_agent_readiness_status_not_applicable(inputs)
});
export { directory_agent_readiness_status_not_applicable as "directory.agent_readiness.status.not_applicable" }